import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useMessages from '../../../../utils/useMessages';
import BusyCover from '../../../../components/controls/BusyCover/BusyCover';
import Heading from '../../../../components/controls/Typography/Heading';
import { apiGET } from '../../../../utils/networking';
import { selectSliceDelegates, setDelegates } from '../../../../store/reducers/delegatesReducer';
import { DelegateListItem } from './components/DelegateListItem/DelegateListItem';
import { DelegateModalAddInvoker } from './components/DelegateModalAdd/DelegateModalAdd';
import { Messages } from '../../../components/messages/Messages';
import Button from '../../../../components/controls/Button';
import { useNavigate } from 'react-router-dom';
import './Delegates.less';

export const ListDelegates = () => {
  const navigate = useNavigate();
  const messages = useMessages();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const { delegates } = useSelector(selectSliceDelegates);

  const render = () => {
    const noDataMessage =
      !loading && delegates.length === 0
        ? 'Start by inviting a delegate to your account by clicking the "Add a Delegate" button below.'
        : null;

    return (<>
      <main className='lsn-page lsn-page-delegates'>
        <div className="link-jump-to-content">
          <a className="skip-to-content-link" href="#delegates">
            Skip to delegates
          </a>
        </div>
        <div className="lsn-container">
          <BusyCover isBusy={loading} />
          <Button
            link
            icon={<i className="fa fa-chevron-left" aria-hidden="true"></i>}
            primary
            className='mb-2'
            onClick={() => {
              // clears the on-screen messages when nav manually
              messages.clear();
              navigate('/dashboard');
            }}
          >
            Back to Requests
          </Button>
          <div className='columns delegates-header-wrapper'>
            <Heading className="column col-2 col-xl-3 col-md-12 text-left no-focus-outline" aria-label={`Delegates`} tabIndex={0}>
              Delegates
            </Heading>
            <div className="column col-10 col-xl-9 col-md-12 notifications">
              <Messages />
            </div>
          </div>

          <div className="columns delegates-wrapper">
            <div className="column col-12" id="delegates">
              {noDataMessage ? <p className="lsn-no-delegates">{noDataMessage}</p> : void 0}
              {delegates.map(delegate => <DelegateListItem delegate={delegate} onChanged={fetchDelegates} />)}
            </div>
          </div>

          <div className='columns'>
            <div className='column col-12 delegates-list-bottom-actions'>
              <DelegateModalAddInvoker onSuccess={fetchDelegates} />
            </div>
          </div>

        </div>
      </main>
    </>
    );
  };

  const fetchDelegates = async () => {
    setLoading(true);
    messages.clear();
    try {
      const resp = await apiGET('/recommendation/rest/evaluatorDelegate');
      dispatch(setDelegates(resp.body));
    } catch (error) {
      console.error(error);
      messages.notifyRed(
        `Cannot fetch your delegates. Please try again or contact help for assistance.`
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    document.title = 'Letters Portal - Delegates';
    fetchDelegates();

    return () => {
      messages.clear();
    }
  }, []);

  return render();
};

export default ListDelegates;
